import "../assets/Textarea.css";
import { jsx as u, Fragment as h, jsxs as r } from "preact/jsx-runtime";
import { forwardRef as o } from "preact/compat";
import { c as i } from "./index.2w0W-O47.js";
const b = "_pulseInputGroup_ztihf_1", f = "_pulseInputInvalid_ztihf_8", N = "_pulseInputLabel_ztihf_12", v = "_pulseInput_ztihf_1", L = "_pulseInputTextArea_ztihf_48", x = "_pulseInputOptionalLabel_ztihf_52", g = "_pulseInputErrorMessage_ztihf_53", p = {
  pulseInputGroup: b,
  pulseInputInvalid: f,
  pulseInputLabel: N,
  pulseInput: v,
  pulseInputTextArea: L,
  pulseInputOptionalLabel: x,
  pulseInputErrorMessage: g
}, c = ({
  valid: t,
  errorMessage: s
}) => /* @__PURE__ */ u(
  "span",
  {
    className: p.pulseInputErrorMessage,
    "aria-live": "assertive",
    "data-testid": "pulse-input-errorMessage",
    children: !t && s ? s : /* @__PURE__ */ u(h, { children: " " })
  }
), d = ({
  id: t,
  label: s,
  required: e
}) => s ? /* @__PURE__ */ r(
  "label",
  {
    className: p.pulseInputLabel,
    htmlFor: t,
    "data-testid": "pulse-input-label",
    children: [
      s,
      !e && /* @__PURE__ */ u(
        "span",
        {
          className: p.pulseInputOptionalLabel,
          "data-testid": "pulse-input-optionalLabel",
          children: " [optional]"
        }
      )
    ]
  }
) : null, m = ({
  children: t,
  valid: s
}) => /* @__PURE__ */ u(
  "div",
  {
    className: i(p.pulseInputGroup, {
      [p.pulseInputInvalid]: !s
    }),
    "data-testid": "pulse-input-group",
    children: t
  }
), G = o(
  ({ id: t, label: s, valid: e = !0, errorMessage: n, ...l }, a) => /* @__PURE__ */ r(m, { valid: e, children: [
    /* @__PURE__ */ u(d, { id: t, label: s, required: !!l.required }),
    /* @__PURE__ */ u(
      "input",
      {
        ref: a,
        id: t,
        ...l,
        className: i(
          p.pulseInput,
          {
            [p.pulseInputInvalid]: !e
          },
          l.className
        ),
        "aria-invalid": e ? void 0 : "true",
        "data-testid": "pulse-input"
      }
    ),
    /* @__PURE__ */ u(c, { valid: e, errorMessage: n })
  ] })
), M = o(
  ({ id: t, label: s, valid: e = !0, errorMessage: n, options: l, ...a }, _) => /* @__PURE__ */ r(m, { valid: e, children: [
    /* @__PURE__ */ u(d, { id: t, label: s, required: !!a.required }),
    /* @__PURE__ */ u(
      "select",
      {
        ref: _,
        id: t,
        ...a,
        className: i(
          p.pulseInput,
          {
            [p.pulseInputInvalid]: !e
          },
          a.className
        ),
        "aria-invalid": e ? void 0 : "true",
        "data-testid": "pulse-select",
        children: l.map((I) => /* @__PURE__ */ u("option", { value: I.value, children: I.label }, I.value))
      }
    ),
    /* @__PURE__ */ u(c, { valid: e, errorMessage: n })
  ] })
), A = o(
  ({ id: t, label: s, valid: e = !0, errorMessage: n, ...l }, a) => /* @__PURE__ */ r(m, { valid: e, children: [
    /* @__PURE__ */ u(d, { id: t, label: s, required: !!l.required }),
    /* @__PURE__ */ u(
      "textarea",
      {
        ref: a,
        id: t,
        ...l,
        className: i(
          p.pulseInput,
          p.pulseInputTextArea,
          {
            [p.pulseInputInvalid]: !e
          },
          l.className
        ),
        "aria-invalid": e ? void 0 : "true",
        "data-testid": "pulse-textarea"
      }
    ),
    /* @__PURE__ */ u(c, { valid: e, errorMessage: n })
  ] })
);
export {
  G as I,
  M as S,
  A as T
};
